import { LOCALE_TO_BCP47_MAP } from '@/i18n/i18n.config';

export const useFormatDate = () => {
  const { locale, d } = useI18n();

  const formatDate = (date, format = 'short') => {
    const targetLocale = LOCALE_TO_BCP47_MAP[locale.value] || locale.value;
    return d(date, format, targetLocale);
  };

  return {
    formatDate,
  };
};
